(() => {
  const mqDesktop = window.matchMedia("(min-width: 750px)");

  function init() {
    const floating = document.getElementById("FloatingATC");
    const floatingBtn = document.getElementById("FloatingATCButton");
    const floatingPrice = document.getElementById("FloatingATCPrice");

    // 商品ページじゃない / 要素がない場合は何もしない
    if (!floating || !floatingBtn) return;

    // 本物のATC（商品フォーム内）
    const realBtn = document.querySelector(
      'product-form button[name="add"], form[action*="/cart/add"] button[name="add"]'
    );
    const realButtonsWrap = document.querySelector(
      "product-form .product-form__buttons, .product-form__buttons"
    );

    if (!realBtn || !realButtonsWrap) return;

    // 価格（テーマ差があるので複数候補）
    const priceEl =
      document.querySelector(".price .price-item--regular") ||
      document.querySelector(".product__info-container .price") ||
      document.querySelector('[data-product-price]');

    const syncPrice = () => {
      if (!floatingPrice) return;
      floatingPrice.textContent = priceEl ? priceEl.textContent.trim() : "";
    };

    // ボタン状態（disabled / 文言）を同期
    const syncButtonState = () => {
      floatingBtn.disabled = realBtn.disabled;
      floatingBtn.textContent = realBtn.textContent.trim() || "カートに追加する";
      floating.setAttribute("aria-hidden", mqDesktop.matches ? "false" : "true");
    };

    // 押したら本物をクリック（Shopifyの通常処理に乗せる）
    floatingBtn.addEventListener("click", () => {
      realBtn.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(() => realBtn.click(), 150);
    });

    // 「本物のボタン群が見えている間はフローティング非表示」
    const setVisible = (v) => {
      if (!mqDesktop.matches) {
        floating.classList.remove("is-visible");
        return;
      }
      floating.classList.toggle("is-visible", v);
    };

    const io = new IntersectionObserver(
      ([entry]) => {
        const inView = entry.isIntersecting && entry.intersectionRatio > 0.2;
        setVisible(!inView);
      },
      { threshold: [0, 0.2, 1] }
    );

    io.observe(realButtonsWrap);

    // 変化（バリアント変更など）を拾う
    const mo = new MutationObserver(() => {
      syncButtonState();
      syncPrice();
    });
    mo.observe(realBtn, { attributes: true, childList: true, subtree: true });
    if (priceEl) mo.observe(priceEl, { childList: true, subtree: true });

    // 初期
    syncButtonState();
    syncPrice();

    mqDesktop.addEventListener?.("change", () => {
      syncButtonState();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();